import { select, Store } from "@ngrx/store";
import { AppState } from "../../reducers";
import { BaseDataSource, QueryResultsModel } from "../../_base/crud";
import { selectRetailStoreAdjustmentQueryResult, selectRetailStoreAdjustmentsPageLoading, selectRetailStoreAdjustmentsShowInitWaitingMessage } from "../_selectors/retail-store-adjustment.selectors";

export class RetailStoreAdjustmentsDataSource extends BaseDataSource {
    trashed = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectRetailStoreAdjustmentsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectRetailStoreAdjustmentsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectRetailStoreAdjustmentQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        })
        
    }
}